﻿export class ContactManager {
    private modal = document.getElementById('contact-modal');
    private openBtn = document.getElementById('global-cta');
    private closeBtn = document.getElementById('close-modal');
    private successCloseBtn = document.getElementById('success-close-btn'); // El nuevo botón
    private form = document.getElementById('contact-form') as HTMLFormElement;
    private headerContent = document.getElementById('modal-header-content');
    private successMsg = document.getElementById('form-success');
    private viewInput = document.getElementById('lead-view') as HTMLInputElement;
    private submitBtn = document.getElementById('submit-lead') as HTMLButtonElement;

    constructor() {
        this.init();
    }

    private init() {
        if (!this.modal || !this.form) return;

        // Conectar botones para abrir y cerrar
        this.openBtn?.addEventListener('click', () => this.openModal());
        this.closeBtn?.addEventListener('click', () => this.closeModal());
        this.successCloseBtn?.addEventListener('click', () => this.closeModal()); // Aquí conectamos el botón que fallaba

        // Cerrar al hacer clic fuera de la caja
        this.modal.addEventListener('click', (e) => {
            if (e.target === this.modal) this.closeModal();
        });

        // Interceptar el envío del formulario
        this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    }

    private openModal() {
        const currentView = window.location.hash.replace('#', '') || 'retail';
        if (this.viewInput) this.viewInput.value = currentView.toUpperCase();
        this.modal?.classList.remove('hidden');
        this.modal?.setAttribute('aria-hidden', 'false');
    }

    private closeModal() {
        this.modal?.classList.add('hidden');
        this.modal?.setAttribute('aria-hidden', 'true');
        // Esperamos 300ms a que termine la animación de fade-out antes de resetear los textos
        setTimeout(() => this.resetForm(), 300);
    }

    private async handleSubmit(e: SubmitEvent) {
        e.preventDefault();

        // Estado visual de carga
        const originalText = this.submitBtn.innerHTML;
        this.submitBtn.innerHTML = 'Procesando...';
        this.submitBtn.style.opacity = '0.7';
        this.submitBtn.disabled = true;

        const formData = new FormData(this.form);
        const payload = {
            name: formData.get('name'),
            email: formData.get('email'),
            interested_view: formData.get('interested_view')
        };

        try {
            const response = await fetch('/api/contact', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (!response.ok) throw new Error('API Error');

            // ÉXITO: Ocultar form y header, mostrar state de éxito
            this.form.classList.add('hidden');
            this.headerContent?.classList.add('hidden');
            this.successMsg?.classList.remove('hidden');

        } catch (error) {
            console.error('Error:', error);
            alert('Tuvimos un problema de red. Por favor, intenta de nuevo.');
            this.submitBtn.innerHTML = originalText;
            this.submitBtn.style.opacity = '1';
            this.submitBtn.disabled = false;
        }
    }

    private resetForm() {
        this.form.reset();
        this.form.classList.remove('hidden');
        this.headerContent?.classList.remove('hidden');
        this.successMsg?.classList.add('hidden');
        this.submitBtn.innerHTML = '<span data-i18n="btn.submit">Solicitar Demo</span>';
        this.submitBtn.style.opacity = '1';
        this.submitBtn.disabled = false;
    }
}